module.exports = __webpack_public_path__ + "Roboto-BlackItalic.ad0f284c7113fd0aaf39.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/rujuta/Desktop/Projects/agiletimes-master/node_modules/roboto-fontface/fonts/roboto/Roboto-BlackItalic.ttf
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BlackItalic.ttf
// module chunks = styles